import {CSSProperties} from 'react';
import css from './button.module.scss';
import {ButtonProps} from './button.types';

const colors: Record<ButtonProps['color'], CSSProperties> = {
	blue: {backgroundColor: 'var(--color-primary)', color: '#FFF'},
	lightBlue: {
		backgroundColor: 'rgba(0, 122, 255, 0.15)',
		color: 'rgba(0, 122, 255, 1)',
	},
	green: {
		backgroundColor: 'rgba(52, 199, 89, 0.15)',
		color: 'rgba(36, 138, 61, 1)',
	},
	red: {
		backgroundColor: 'rgba(255, 0, 0, 0.15)',
		color: 'rgba(215, 0, 21, 1)',
	},
};

const setDisableStyle = (disabled: ButtonProps['disabled']): CSSProperties => {
	return {opacity: disabled ? '0.3' : undefined};
};

const setStyles = (props: ButtonProps) => {
	const disableStyles = setDisableStyle(props.disabled);
	return {...colors[props.color], ...disableStyles};
};

export const Button = (props: ButtonProps): JSX.Element => {
	return (
		<button onClick={props.onClick} style={setStyles(props)} className={css.container} disabled={props.disabled}>
			{props.icon && <img width={16} className={css.icon} src={props.icon} />}
			<div>{props.name}</div>
		</button>
	);
};
